import React, { useState, useContext, useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { TextField } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'

// components
import Phone from '../components/fields/Phone'

// utils
import { getBaseUrl } from '../utils'
import { validateFields } from '../utils/validation'

// layout
import Layout from '../layout'

// styles
import { useStyles } from '../styles/common.style'

// store
import { Context } from '../store'
import types from '../store/types'

// API
import { userSignedAgreement } from '../API'

import { t } from 'application-translator/dist/translate/translate.react.js';

function Sorry() {
  const classes = useStyles()

  // global state
  const { globalState, dispatch } = useContext(Context)
  const { signedBy, signedEmail, phone, agreed, countryCode } =
    globalState.userData || {}

  // router hooks
  const location = useLocation()
  const history = useHistory()

  // local state
  const [baseUrl, setBaseUrl] = useState('/')

  useEffect(() => {
    const { pathname } = location
    const baseUrl = getBaseUrl(pathname)
    setBaseUrl(baseUrl)
  }, [])

  return (
    <Layout title={t('Sorry')}>
      <div className={classes.content}>
        <p>{t('We encountered an issue.')}</p>
        <p>{t('Please contact our support team or go back and try again.')}</p>

        <Button
          variant="contained"
          color="primary"
          type="button"
          onClick={() => history.push(`${baseUrl}`)}
        >
          {t('Go Back')}
        </Button>
      </div>
    </Layout>
  )
}

export default Sorry
